import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const PaymentRefusalDetailPage = lazyWithRetry(() =>
  import("@/features/payment-refusals/pages/PaymentRefusalDetailPage").then((m) => ({ default: m.PaymentRefusalDetailPage })),
);

export const PAYMENT_REFUSAL_DETAIL_PATH = (id = ":id") => `/payment-refusal/${id}`;

const paymentRefusalsRoutes: RouteConfig[] = [
  {
    path: PAYMENT_REFUSAL_DETAIL_PATH(),
    element: <PaymentRefusalDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default paymentRefusalsRoutes;
